var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({staticClass:"button btn",class:[
    _vm.otherColor || _vm.color,
    _vm.position,
    _vm.className,
    {long: _vm.long},
    {hidden: _vm.hidden},
    {'no-mobile': _vm.noMobile}
  ],attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[_c('span',{staticClass:"button-content"},[_c('span',{staticClass:"button-hover-slide"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"button-hover-content"},[_vm._t("default")],2)],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }